//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppCardCode from '@core/components/app-card-code/AppCardCode.vue'

// demos
import DemoPaginationBasic from './demos/DemoPaginationBasic.vue'
import DemoPaginationColor from './demos/DemoPaginationColor.vue'
import DemoPaginationCircle from './demos/DemoPaginationCircle.vue'
import DemoPaginationDisabled from './demos/DemoPaginationDisabled.vue'
import DemoPaginationIcons from './demos/DemoPaginationIcons.vue'
import DemoPaginationLength from './demos/DemoPaginationLength.vue'
import DemoPaginationTotalVisible from './demos/DemoPaginationTotalVisible.vue'

// code
import {
  paginationBasic,
  paginationColor,
  paginationCircle,
  paginationDisabled,
  paginationIcons,
  paginationLength,
  paginationTotalVisible,
} from './demos/code'

export default {
  components: {
    AppCardCode,
    DemoPaginationBasic,
    DemoPaginationColor,
    DemoPaginationCircle,
    DemoPaginationDisabled,
    DemoPaginationIcons,
    DemoPaginationLength,
    DemoPaginationTotalVisible,
  },
  setup() {
    return {
      codeSnippets: {
        paginationBasic,
        paginationColor,
        paginationCircle,
        paginationDisabled,
        paginationIcons,
        paginationLength,
        paginationTotalVisible,
      },
    }
  },
}
